<div fxLayout="row" fxLayoutAlign="center end" class="vertical-bar">
  @for (row of chartData; track getData(row, listTitleProp)) {
    <div fxLayout="column" fxLayoutAlign="end center" [ngStyle]="{'width': barWidth, 'height':'100%'}" >
      <div fxLayout="column" fxLayoutAlign="start center"
        [ngClass]="getData(row, listValueProp) !== 0 ? 'vertical-bar__fill' : 'vertical-bar__empty-fill'"
     [ngStyle]="{'height': getBarPercentage(row, listValueProp),
                 'width': '85%',
                 'background-color': getData(row, listValueProp) !== 0 ? setColor(row) : '',
                 'border-color': getData(row, listValueProp) === 0 ? setColor(row) : ''
                }">
        <div [ngClass]="getData(row, listValueProp) !== 0 ? 'vertical-bar__value' : 'vertical-bar__empty-value'"
          [attr.data-testid]="getData(row, listValueProp) + '-vertical-bar-chart-number'">
          {{getData(row, listValueProp)}}
        </div>
      </div>
      <div class="vertical-bar__title-{{category}}" [attr.data-testid]="getData(row, listTitleProp) + '-vertical-bar-chart-text'">
        {{getData(row, listTitleProp)}}
      </div>
    </div>
  }
</div>
